import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DisplayContent } from 'sg-ui-components';

import LoadingIndicator from '../Components/LoadingIndicator';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import UserLockout from '../utils/user_lockout';

const LongPlayCollections = ({ config, longPlayGame, revealToken, actions }) => {
    const [pageLoaded, setPageLoaded] = useState(false);
    const [gameLoading, setGameLoading] = useState(false);

    const [boardId, setBoardId] = useState(null);
    const [gameUrl, setGameUrl] = useState(null);

    //TODO for the BE: this needs to be dynamic
    const longPlayGames = [
        {
            id: 3,
            name: 'Lucky Letters',
            animationId: '66f6d8656d7056034e807f88',
        },
    ];

    const gameId = 3;

    const animationId = longPlayGames.find((game) => game.id === gameId)?.animationId;
    const gameServer = config?.config?.reveal_host ?? '';

    const boards = longPlayGame?.boards?.[gameId] ?? [];

    const firstBoardId = boards?.[0]?.board_serial;

    const winsAndPrizes = longPlayGame?.winsAndPrizes?.[gameId] ?? [];
    const gameBoardDetails = longPlayGame?.boardDetails?.[boardId] ?? {};

    useEffect(() => {
        async function fetchData() {
            await actions?.revealTokenActions?.getRevealToken();
            await actions?.longPlayGameActions?.getBoards(gameId);
            await actions?.longPlayGameActions?.getWinsAndPrizes(gameId);
            setPageLoaded(true);
        }

        fetchData();

        return () => {
            setPageLoaded(false);
        };
    }, []);

    useEffect(() => {
        // console.log('🔥 board ID changes', boardId);
        if (boardId) {
            setGameLoading(true);
            getBoardDetails();
            setGameUrl('');
        }
    }, [boardId]);

    useEffect(() => {
        // console.log('🔥 board ID Data changes', longPlayGame?.boardDetails?.[boardId]?.serial);
        if (longPlayGame?.boardDetails?.[boardId]?.serial) {
            setGameLoading(true);
            getGameUrl();
        }
    }, [longPlayGame?.boardDetails?.[boardId]?.serial]);

    // Animations can handle events for us
    const gameEventListener = (event) => {
        //? For debug: console.log('🔥', event);

        if (event.data === undefined) {
            return;
        }
    };

    // Call IGR to get the game URL
    async function getGameUrl() {
        setGameUrl('');
        setGameLoading(true);

        const igrGamesPattern = /^[A-Fa-f0-9]+$/g;
        if (animationId.match(igrGamesPattern) && gameId && revealToken.revealToken && gameBoardDetails?.board) {
            const gameOutcome = {
                entries: 1,
                percentage: 0,
                multiplier: 0,
                win_types: winsAndPrizes ?? [],
                game_awards: {},
                gamepieces: gameBoardDetails?.board?.gamepieces ?? [],
                wins: gameBoardDetails?.board?.wins ?? [],
            };

            const gameOptions = {
                gameId: animationId,
                serverType: 'Static',
                outcomeData: gameOutcome,
                sageOptions: {
                    promotionId: 1,
                    leaderBoardId: 1,
                },
                additionalData: {},
                useMinimized: false,
            };

            const gameData = 'options=' + encodeURIComponent(JSON.stringify(gameOptions));
            const revealUrl = `${gameServer}/api/games/url?token=${revealToken.revealToken ?? ''}`;

            const xhr = new XMLHttpRequest();
            xhr.addEventListener('readystatechange', () => {
                if (xhr.readyState === 4) {
                    try {
                        const responseObj = JSON.parse(xhr.responseText);
                        setGameUrl(responseObj.gameUrl);
                        setGameLoading(false);
                        window.addEventListener('message', gameEventListener);
                    } catch (err) {
                        console.error('Could not retrieve game URL - ', err);
                    }
                }
            });

            xhr.open('POST', revealUrl);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.send(gameData);
        } else {
            console.error('🔴 Reveal token or animation id is not exists');
            setGameLoading(false);
        }
    }

    async function getBoardDetails() {
        await actions?.longPlayGameActions?.getBoard({ game_id: gameId, board_id: boardId });
    }

    // console.log('🚒', longPlayGame);
    // console.log('🕹️ Boards', boards);
    // console.log('🕹️ Wins and Prizes', winsAndPrizes);
    // console.log('🕹️ Selected Game Board', gameBoardDetails);
    // console.log('🔥', gameLoading);

    useEffect(() => {
        console.log('🚀 First Board ID', firstBoardId);
        if (firstBoardId) {
            setBoardId(firstBoardId);
        }
    }, [firstBoardId]);

    return (
        <UserLockout>
            <DisplayContent isVisible={pageLoaded}>
                {/*
                <ListGroup defaultActiveKey='#board-0'>
                    {boards.map((board, index) => {
                        return (
                            <ListGroup.Item key={index} action href={`#board-${index + 1}`} onClick={() => setBoardId(board?.board_serial ?? '')}>
                                ID: {board?.id} | State: {board?.state} | Game pieces: {board?.gamepieces?.length ?? 0}
                            </ListGroup.Item>
                        );
                    })}
                </ListGroup>
                */}

                <DisplayContent isVisible={gameLoading}>
                    <LoadingIndicator priority='low' />
                </DisplayContent>

                {/* <DisplayContent isVisible={gameBoardDetails?.board}>
                        <button onClick={() => getGameUrl() }>Get game content: {boardId}</button>
                    </DisplayContent> */}

                <DisplayContent isVisible={gameUrl?.length}>
                    <div id='reveal-game-container'>
                        <iframe
                            data-testid={'gameplay-iframe'}
                            title='interactive-reveal'
                            className='interactive-reveal-iframe'
                            src={gameUrl ?? ''}
                            allow='accelerometer; gyroscope;'
                            frameBorder='0'></iframe>
                    </div>
                </DisplayContent>
            </DisplayContent>
        </UserLockout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LongPlayCollections);
